import { Link } from 'react-router-dom';
import { Menu, X, LogOut } from 'lucide-react';
import { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';

const navLinks = [
  { href: '/services', label: 'Services', testId: 'header-services' },
  { href: '/tools', label: 'Tools', testId: 'header-tools' },
  { href: '/projects', label: 'Projects', testId: 'header-projects' },
  { href: '/resources', label: 'Resources', testId: 'header-resources' },
  { href: '/pricing', label: 'Pricing', testId: 'header-pricing' },
  { href: '/contact', label: 'Contact', testId: 'header-contact' },
];

export function Header() {
  const { isAuthenticated, user, logout } = useAuth();
  const [isOpen, setIsOpen] = useState(false);

  const handleLogout = () => {
    logout();
    setIsOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 w-full bg-white/80 backdrop-blur-sm border-b border-slate-200">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="text-2xl font-bold text-slate-900">
            Cal-Spec
          </Link>
          <nav className="hidden md:flex items-center space-x-6">
            {navLinks.map((link) => (
              <Link key={link.href} to={link.href} data-testid={link.testId} className="text-slate-600 hover:text-slate-900">
                {link.label}
              </Link>
            ))}
            {isAuthenticated ? (
              <>
                <span className="text-sm text-slate-600">Welcome, {user?.firstName}</span>
                <button
                  onClick={handleLogout}
                  className="flex items-center px-4 py-2 text-sm font-medium text-white bg-red-500 rounded-md hover:bg-red-600"
                >
                  <LogOut className="w-4 h-4 mr-2" />
                  Logout
                </button>
              </>
            ) : (
              <Link to="/login" className="px-4 py-2 text-sm font-medium text-white bg-blue-500 rounded-md hover:bg-blue-600">
                Client Login/Register
              </Link>
            )}
          </nav>
          <div className="md:hidden">
            <button onClick={() => setIsOpen(!isOpen)}>
              {isOpen ? <X /> : <Menu />}
            </button>
          </div>
        </div>
      </div>
      {isOpen && (
        <div className="md:hidden">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            {navLinks.map((link) => (
              <Link key={link.href} to={link.href} data-testid={`${link.testId}-mobile`} className="block px-3 py-2 rounded-md text-base font-medium text-slate-600 hover:text-slate-900 hover:bg-slate-100">
                {link.label}
              </Link>
            ))}
            {isAuthenticated ? (
              <>
                <div className="px-3 py-2 text-sm text-slate-600">
                  Welcome, {user?.firstName}
                </div>
                <button
                  onClick={handleLogout}
                  className="flex items-center justify-center w-full px-3 py-2 mt-2 text-center text-white bg-red-500 rounded-md hover:bg-red-600"
                >
                  <LogOut className="w-4 h-4 mr-2" />
                  Logout
                </button>
              </>
            ) : (
              <Link to="/login" className="block w-full px-3 py-2 mt-2 text-center text-white bg-blue-500 rounded-md hover:bg-blue-600">
                Client Login/Register
              </Link>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
